import { service } from '@/utils/request'

export default {
	// 查询列表
	getDataList(params) {
		return service({
			url: '/cloud/course/offline/product/admin/page',
			method: 'get',
			params: params
		})
	},
	// 更新
	updateData(params) {
		return service({
			url: '/cloud/course/offline/product/admin/update',
			method: 'post',
			data: params
		})
	},
	// 删除
	deleteData(path) {
		return service({
			url: '/cloud/course/offline/product/admin/delete/'+path,
			method: 'post'
		})
	},
	// 获取 详情
	getDetail(path) {
		return service({
			url: '/cloud/course/offline/product/admin/get/'+path,
			method: 'get'
		})
	},
	// 添加
	addData(data) {
		return service({
			url: '/cloud/course/offline/product/admin/add',
			method: 'post',
			data: data
		})
	},
	// 修改
	modifyData(data) {
		return service({
			url: '/cloud/course/offline/product/admin/update',
			method: 'post',
			data: data
		})
	},
	// 添加班级
	addClass(data) {
		return service({
			url: '/cloud/course/offline/product/admin/class/add',
			method: 'post',
			data: data
		})
	},
	// 添加套餐
	addPackage(data) {
		return service({
			url: '/cloud/course/offline/product/admin/price/add',
			method: 'post',
			data: data
		})
	},
	// 修改班级
	modifyClass(data) {
		return service({
			url: '/cloud/course/offline/product/admin/class/update',
			method: 'post',
			data: data
		})
	},
	// 修改套餐
	modifyPackage(data) {
		return service({
			url: '/cloud/course/offline/product/admin/price/update',
			method: 'post',
			data: data
		})
	},
	// 删除班级
	deleteClass(path) {
		return service({
			url: '/cloud/course/offline/product/admin/class/delete/' + path,
			method: 'post'
		})
	},
	// 删除套餐
	deletePackage(path) {
		return service({
			url: '/cloud/course/offline/product/admin/price/delete/' + path,
			method: 'post'
		})
	},
}


// WEBPACK FOOTER //
// ./src/api/contentManage/operationmanage.js